// Currency.js
export const SET_CURRENCY_NAME = "SET_CURRENCY_NAME";
export const SET_CURRENCY_RATE = "SET_CURRENCY_RATE";
export const SET_CURRENCY_STEEMRATE = "SET_CURRENCY_STEEMRATE";
export const SET_CURRENCY_SBDRATE = "SET_CURRENCY_SBDRATE";

export const SET_CURRENCY_SYMBOL = "SET_CURRENCY_SYMBOL";
export const SET_CURRENCY_LAST_CONVERSION = "SET_CURRENCY_LAST_CONVERSION";

// UI.js
export const SET_UI_LANGUAGE = "SET_UI_LANGUAGE";
export const SET_UI_LOGIN = "SET_UI_LOGIN";
export const SET_UI_LOCALE = "SET_UI_LOCALE";
export const SET_UI_NIGHT_MODE = "SET_UI_NIGHT_MODE";
export const SET_UI_HEADER_TYPE = "SET_UI_HEADER_TYPE";
export const SET_UI_MENU_VISIBLE = "SET_UI_MENU_VISIBLE";
export const SET_UI_HAS_ACCEPTED_LINK_DISCLAIMER = "SET_UI_HAS_ACCEPTED_LINK_DISCLAIMER";
export const SET_UI_PRICE_CHART_OPTIONS = "SET_UI_PRICE_CHART_OPTIONS";
export const SET_UI_VOLUME_CHART_OPTIONS = "SET_UI_VOLUME_CHART_OPTIONS";
export const SET_UI_BLOCK_SORT_PARAMS = "SET_UI_BLOCK_SORT_PARAMS";
export const SET_UI_BUSINESS_SORT_PARAMS = "SET_UI_BUSINESS_SORT_PARAMS";
export const SET_UI_BRIDGECHAIN_SORT_PARAMS = "SET_UI_BRIDGECHAIN_SORT_PARAMS";
export const SET_UI_DELEGATE_SORT_PARAMS = "SET_UI_DELEGATE_SORT_PARAMS";
export const SET_UI_TRANSACTION_SORT_PARAMS = "SET_UI_TRANSACTION_SORT_PARAMS";
export const SET_UI_WALLET_SORT_PARAMS = "SET_UI_WALLET_SORT_PARAMS";
export const SET_UI_WALLET_SEARCH_SORT_PARAMS = "SET_UI_WALLET_SEARCH_SORT_PARAMS";
export const SET_UI_WALLET_TRANSACTION_TAB = "SET_UI_WALLET_TRANSACTION_TAB";

// Delegates.js
export const SET_DELEGATES = "SET_DELEGATES";
export const SET_FORGED = "SET_FORGED";
export const SET_DELEGATES_COUNT = "SET_DELEGATES_COUNT";

// Network.js
export const SET_NETWORK_DEFAULTS = "SET_NETWORK_DEFAULTS";
export const SET_NETWORK_SERVER = "SET_NETWORK_SERVER";
export const SET_NETWORK_TOKEN = "SET_NETWORK_TOKEN";
export const SET_NETWORK_TOKEN_IS_LISTED = "SET_NETWORK_TOKEN_IS_LISTED";
export const SET_NETWORK_SYMBOL = "SET_NETWORK_SYMBOL";
export const SET_NETWORK_NETHASH = "SET_NETWORK_NETHASH";
export const SET_NETWORK_CURRENCIES = "SET_NETWORK_CURRENCIES";
export const SET_NETWORK_KNOWN_ACCOUNTS = "SET_NETWORK_KNOWN_ACCOUNTS";
export const SET_NETWORK_KNOWN_SEEDS = "SET_NETWORK_KNOWN_SEEDS";
export const SET_NETWORK_KNOWN_RPCS = "SET_NETWORK_KNOWN_RPCS";
export const SET_NETWORK_KNOWN_APPS = "SET_NETWORK_KNOWN_APPS";
export const SET_NETWORK_PROPERTIES = "SET_NETWORK_PROPERTIES";
export const SET_NETWORK_SUPPLY = "SET_NETWORK_SUPPLY";
export const SET_NETWORK_SBD_SUPPLY = "SET_NETWORK_SBD_SUPPLY";
export const SET_NETWORK_INITIAL_SUPPLY = "SET_NETWORK_INITIAL_SUPPLY";
export const SET_NETWORK_HEIGHT = "SET_NETWORK_HEIGHT";
export const SET_NETWORK_EPOCH = "SET_NETWORK_EPOCH";
export const SET_NETWORK_BLOCKTIME = "SET_NETWORK_BLOCKTIME";
export const SET_NETWORK_ALIAS = "SET_NETWORK_ALIAS";
export const SET_NETWORK_ACTIVE_DELEGATES = "SET_NETWORK_ACTIVE_DELEGATES";
export const SET_NETWORK_REWARD_OFFSET = "SET_NETWORK_REWARD_OFFSET";
export const SET_NETWORK_ADDRESS_PREFIX = "SET_NETWORK_ADDRESS_PREFIX";
export const SET_NETWORK_HAS_MAGISTRATE_ENABLED = "SET_NETWORK_HAS_MAGISTRATE_ENABLED";
export const SET_NETWORK_HAS_HTLC_ENABLED = "SET_NETWORK_HAS_HTLC_ENABLED";
export const SET_NETWORK_ENABLED_TRANSACTION_TYPES = "SET_NETWORK_ENABLED_TRANSACTION_TYPES";
export const SET_NETWORK_ENABLED_CURRENCIES_TYPES = "SET_NETWORK_ENABLED_CURRENCIES_TYPES";
export const SET_NETWORK_APPS = "SET_NETWORK_APPS";
export const SET_NETWORK_TOP_APPS = "SET_NETWORK_TOP_APPS";
